/**
 * @typedef {Object} ViewContentItem - Items list within parameters sent with view-content events
 * @type Object
 * @property {string|number} id
 * @property {string} title
 * @property {number} price
 * @property {number} quantity
 */

/**
 * @typedef {Object} ViewContentParams - Parameters sent with view-content events
 * @type Object
 * @property {string} contentType - The type of content being viewed
 * @property {number} value - The value of the content being viewed (e.g. product price, cart value, etc)
 * @property {string} currency - The currency code for the value
 * @property {Array.<ViewContentItem>} items
 * @property {boolean} postCheckout - `true` if the content being viewed is after checkout has occurred.
 */

/**
 * @typedef {Object} AddToCartParams - Parameters sent with AddToCart events
 * @type Object
 * @property {string} name - The name of the item being added to the cart
 * @property {(number|Array<number>)} variants - The IDs of the item(s) being added to the cart
 * @property {'product'|'product_group'} type - The type of item(s) being added to the cart
 * @property {number} quantity - The quantity of item(s) being added to the cart
 * @property {number} value - The value of the item(s) being added to the cart
 * @property {string} currency - The currency code for the value of the cart
 */

/**
 * Event Type values enum
 * @readonly
 * @enum {string}
 */
export const EventTypes = {
  /**
   * Fired when Offer Id has been identified on the current page.
   */
  OFFER_ID: 'offerid',
  /**
   * Fired when IP Address information has been obtained for the current visitor.
   */
  IP_ADDRESS_INFO: 'ipinfo',
  /**
   * Fired when viewing product content.
   */
  VIEW_CONTENT: 'view-content',
  /**
   * Fired when an item is added to the cart.
   */
  ADD_TO_CART: 'AddToCart',
  /**
   * Fired when the shopping cart is viewed.
   */
  VIEW_CART: 'ViewCart',
  /**
   * Fired when an upsell page is being viewed.
   */
  UPSELL: 'upsell',
  /**
   * Fired when a purchase is made.
   */
  PURCHASE: 'make_purchase',
};
